import { falconClients } from "../clients/falcon.client";
import { DataResponseUser, User, UserCreateRequest, UserSearchRequest, UserUpdateRequest } from "@bluefalcon/users-management-client-fetch";

export class UsersService {

    async createUser(request: UserCreateRequest): Promise<User> {
        return falconClients.admin.createUserAdmin({
            userCreateRequest: request,
        });
    }

    async updateUserById(id: string, request: UserUpdateRequest): Promise<User> {
        return falconClients.admin.updateUserByIdAdmin({
            id,
            userUpdateRequest: request,
        });
    }

    async searchUsers(request: UserSearchRequest): Promise<DataResponseUser> {
        return falconClients.admin.searchUsersAdmin({
            userSearchRequest: request,
        });
    }

    async getUserById(id: string): Promise<User> {
        return falconClients.admin.getUserByIdAdmin({ id });
    }

    async addRoleToUser(userId: string, roleId: number): Promise<User> {
        return falconClients.admin.updateUserByIdAdmin({
            id: userId,
            userUpdateRequest: {
                role: {
                    add: [roleId],
                },
            },
        });
    }

    async removeRoleFromUser(userId: string, roleId: number): Promise<User> {
        return falconClients.admin.updateUserByIdAdmin({
            id: userId,
            userUpdateRequest: {
                role: {
                    remove: [roleId],
                },
            },
        });
    }
}
